/* AG: 2025-06-09 15:50:19 */
<script setup lang="ts">
import BaseButton from '@c/common/Button.vue';
import BaseEmpty from '@c/common/Empty.vue';
import { GlossaryTerm } from '../types';
import GlossaryShare from './Share.vue';
// 定义组件属性
defineProps<{
    isM?: boolean
    // 术语详情
    term: GlossaryTerm | null
}>();

const router = useRouter();
</script>

<template>
  <div class="flex-1 flex flex-col">
    <section
      class="flex items-center text-sm-r c-[--gray-500] gap-x-4px"
      :class="[isM ? 'px-16px py-24px bg-[linear-gradient(4deg,#ffffff_3.13%,#f5f5ff_40.08%)]' : 'mb-32px']"
    >
      <router-link
        to="/"
        class="whitespace-nowrap hover:underline"
      >
        {{ $t('glossary.home') }}
      </router-link>
      <span class="c-[--gray-300]">/</span>
      <router-link
        to="/glossary"
        class="whitespace-nowrap hover:underline"
      >
        {{ $t('glossary.label') }}
      </router-link>
      <template
        v-if="term"
      >
        <span class="c-[--gray-300]">/</span>
        <span class="fw-500 c-[--gray-900]">
          {{ term.title }}
        </span>
      </template>
    </section>
    <div
      class="flex-1 flex flex-col"
      :class="[isM ? 'px-16px' : '']"
    >
      <!-- 术语不存在 -->
      <section v-if="!term" class="flex-1 flex flex-col items-center justify-center -mt-32px">
        <BaseEmpty
          size="large"
          :text="$t('glossary.empty')"
        />
        <BaseButton
          type="black"
          size="small-large"
          class="min-w-240px mt-32px"
          @click="router.replace('/glossary')"
        >
          {{ $t('返回上一级') }}
        </BaseButton>
      </section>

      <!-- 术语详情 -->
      <section v-else>
        <div class="flex justify-between items-center mb-32px">
          <section>
            <!-- 标题 -->
            <h1
              class="fw-700 c-black"
              :class="[isM ? 'text-display-sm-sb' : 'text-display-md-sb']"
            >
              {{ term.title }}
            </h1>
            <p class="pt-16px text-sm-r c-[--gray-600]">
              {{$t('glossary.updated')}}
            </p>
          </section>
          <GlossaryShare
            v-if="!isM"
            :term="term"
          />
        </div>

        <!-- 内容 -->
        <div
          v-if="term.content"
          class="content [&_a]:underline [&_img]:max-w-full"
          :class="[isM ?
            `text-14px lh-20px c-[--gray-500]
            [&_h2]:text-20px [&_h2]:lh-30px [&_h2]:fw-600 [&_h2]:c-black [&_h2]:mt-18px [&_h2]:mb-12px
            [&_h3]:text-18px [&_h3]:lh-28px [&_h3]:fw-600 [&_h3]:c-black [&_h3]:mt-18px [&_h3]:mb-12px
            [&_h4]:text-16px [&_h4]:lh-24px [&_h4]:fw-600 [&_h4]:c-black [&_h4]:mt-18px [&_h4]:mb-12px
            [&_div]:mb-10px [&_p]:mb-10px [&_ul]:mb-10px [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-y-8px`
            : `text-16px lh-24px c-[--gray-800]
              [&_h2]:text-24px [&_h2]:lh-32px [&_h2]:fw-700 [&_h2]:c-black [&_h2]:mt-24px [&_h2]:mb-16px
              [&_h3]:text-20px [&_h3]:lh-30px [&_h3]:fw-700 [&_h3]:c-black [&_h3]:mt-24px [&_h3]:mb-16px
              [&_h4]:text-18px [&_h4]:lh-28px [&_h4]:fw-700 [&_h4]:c-black [&_h4]:mt-24px [&_h4]:mb-16px
              [&_div]:mb-10px [&_p]:mb-10px [&_ul]:mb-10px [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-y-8px`
          ]"
          v-html="term.content"
        />
        <GlossaryShare
          v-if="isM"
          :term="term"
          class="mt-24px"
        />
      </section>
    </div>
  </div>
</template>
/* AG: 2025-06-09 15:50:19 */
<style scoped lang="scss">
.content {
  font-family: 'IBMPlexSans-Regular', 'NotoSansSC-Regular' !important;

  :deep(h2:first-child) {
    margin-top: 0 !important;
  }
}
</style>